module.exports.cities = ['Atlanta', 'Austin', 'Boston', 'Houston', 'Dallas', 'San Antonio', 'East Bay', 'San Francisco', 'Silicon Valley',
  'Santa Barbara', 'Los Angeles', 'Orange County', 'San Diego', 'Seattle', 'Portland', 'Toronto', 'Boulder', 'Denver',
  'Jacksonville', 'Tampa', 'Orlando', 'Miami', 'Detroit', 'Pittsburgh', 'Philadelphia', 'Phoenix', 'Minneapolis', 'Salt Lake City',
  'Washington DC', 'Nashville', 'St Louis', 'New York City', 'Raleigh Durham', 'Kansas City', 'Charlotte',
  'Baltimore', 'Bangalore', 'Berlin', 'Chicago', 'Cleveland', 'Dublin', 'Las Vegas', 'London', 'Paris', 'Singapore', 'Stockholm', 'Sydney', 'Tel Aviv', 'Vancouver'
]
module.exports._location = {
  "AL": "Alabama",
  "AK": "Alaska",
  "AS": "American Samoa",
  "AZ": "Arizona",
  "AR": "Arkansas",
  "CA": "California",
  "CO": "Colorado",
  "CT": "Connecticut",
  "DE": "Delaware",
  "DC": "District Of Columbia",
  "FM": "Federated States Of Micronesia",
  "FL": "Florida",
  "GA": "Georgia",
  "GU": "Guam",
  "HI": "Hawaii",
  "ID": "Idaho",
  "IL": "Illinois",
  "IN": "Indiana",
  "IA": "Iowa",
  "KS": "Kansas",
  "KY": "Kentucky",
  "LA": "Louisiana",
  "ME": "Maine",
  "MH": "Marshall Islands",
  "MD": "Maryland",
  "MA": "Massachusetts",
  "MI": "Michigan",
  "MN": "Minnesota",
  "MS": "Mississippi",
  "MO": "Missouri",
  "MT": "Montana",
  "NE": "Nebraska",
  "NV": "Nevada",
  "NH": "New Hampshire",
  "NJ": "New Jersey",
  "NM": "New Mexico",
  "NY": "New York",
  "NC": "North Carolina",
  "ND": "North Dakota",
  "MP": "Northern Mariana Islands",
  "OH": "Ohio",
  "OK": "Oklahoma",
  "OR": "Oregon",
  "PW": "Palau",
  "PA": "Pennsylvania",
  "PR": "Puerto Rico",
  "RI": "Rhode Island",
  "SC": "South Carolina",
  "SD": "South Dakota",
  "TN": "Tennessee",
  "TX": "Texas",
  "UT": "Utah",
  "VT": "Vermont",
  "VI": "Virgin Islands",
  "VA": "Virginia",
  "WA": "Washington",
  "WV": "West Virginia",
  "WI": "Wisconsin",
  "WY": "Wyoming"
}
module.exports.industry = [
  'Cannabis',
  'Fintech',
  'Tech Services',
  'Education',
  'Construction',
  'Finance',
  'Real Estate',
  'Marketing',
  'Fintech',
  'Government',
  'NonProfit',
  'Food',
  'Automotive',
  'Consumer',
  'Analytics',
  'Environmental',
  'Retail',
  'Legal',
  'Engineering',
  'Biotech',
  'Health',
  'Electronics',
  'Hospitality',
  'Insurance',
  'Recruiting',
  'Telecom',
  'Media',
  'Medical Equip',
  'Consulting',
  'Transportation',
  'Banking',
  'Logistics',
  'Aviation',
  'Research',
  'Digital Health',
  'Pharma',
  'AI',
  'Entertainment',
  'Machinery',
  'EdTech',
  'Materials',
  'Leisure',
  'IT Security',
  'Sports',
  'Investments',
  'Utilities',
  'Apparel',
  'HR',
  'Wholesale',
  'Design',
  'Accounting',



]
module.exports.industry2 = [
  'Learning',
  'Architecture',
  'Mining',
  'Medical Offices',
  'Restaurants',
  'Facilities',
  'Gaming',
  'Publishing',
  'Defense',
  'Chemicals',
  'Social Services',
  '3D',
  'Industrial',
  'Martech',
  'Events',
  'Civil',
  'Security',
  'Training',
  'Technology',
  'Printing',
  'Packaging',
  'Trade',
  'Farming',
  'HRTech',
  'Furniture',
  'Plastics',
  'Semiconductors',
  'Supplies',
  'Outsource',
  'Babytech',
  'Religious',
  'Music',
  'Maritime',
  'Museums',
  'Cosmetics',
  'Adtech',
  'Hardware',
  'Arts',
  'Beverages',
  'Newspapers',
  'Wireless',
  'eCommerceTech',
  'Textiles',
  'Real Estate Tech',
  'Law',
  'Philanthropy',
  'Casinos',
  'Salestech',
  'Foodtech',
  'Networking',
  'Recreation',
  'Healthcare',
  'Event Tech',
  'Veterinary',
  'Movies',
  'Cannabis',
  'Investment Banks',
  'Paper',
  'SaaS',
  'Military',
  'IT Services and IT Consulting',
  'Think Tanks',
  'Translation',
  'Libraries',
  'Fund-Raising',
  'DevOps',
  'Photography',
  'Program Dev',
  'Executive',
  'Writing',
  'Warehousing',
  'Hospitals and Health Care',
  'Animation',
  'Legaltech',
  'Manufacturing',
  'Supermarkets',
  'Dairy',
  'Concreate',
  'Information Technology & Services',
  'Shipbuilding',
  'Software Development',
  'Non-profit Organizations',
  'Business Intelligence',
  'Leasing Real Estate',
  'Wellness and Fitness Services',
  'Medical',
  'Govtech',
  'Judiciary',
  'Robotics',
  'IoT',
  'Internet Publishing',
  'Motor Vehicle Manufacturing',
  'ProductivityTech',
  'Education Administration Programs',
  'Food and Beverage Services',
  'Marketing Services',
  'Biotechnology Research',
  'Renewable Energy Semiconductor Manufacturing',
  'Truck Transportation',
  'eCommerce',
  'Business Consulting and Services',
  'Medical Equipment Manufacturing',
  'Pharmaceutical Manufacturing',
  'Legislative',
  'Human Resources Services',
  'Oil and Gas',
  'Fishery',
  'Delivery'
]

module.exports.pieChartData_industry = {
  Fintech: [
    { name: 'Payments/Transfer', value: 109, color: 'RGB(111, 143, 147)' },
    { name: 'Lending', value: 80, color: 'RGB(195, 206, 170)' },
    { name: 'Blockchain', value: 49, color: 'RGB(170, 182, 110)' },
    { name: 'Investments', value: 81, color: 'RGB(132, 154, 167)' },
    { name: 'Consumer Finance', value: 31, color: 'RGB(228, 114, 87)' },
    { name: 'Financial/Compliance SaaS', value: 42, color: 'RGB(65, 104, 138)' },
    { name: 'Banking as a Service', value: 20, color: 'RGB(95, 104, 138)' },
    { name: 'Insurance', value: 11, color: 'RGB(65, 184, 138)' },
  ],
}

module.exports.pieChartData = {
  Boston: [
    { name: 'Biotech/Pharma', value: 31, color: 'RGB(111, 143, 147)' },
    { name: 'Internet', value: 10, color: 'RGB(195, 206, 170)' },
    { name: 'Tech Services', value: 10, color: 'RGB(170, 182, 110)' },
    { name: 'Hospital/Health', value: 7, color: 'RGB(132, 154, 167)' },
    { name: 'Finance', value: 7, color: 'RGB(228, 114, 87)' },
    { name: 'Marketing', value: 5, color: 'RGB(65, 104, 138)' },
  ],
  Austin: [
    { name: 'FinTech', value: 8, color: 'RGB(111, 143, 147)' },
    { name: 'Biotech/Health', value: 10, color: 'RGB(195, 206, 170)' },
    { name: 'Education/Learning', value: 6, color: 'RGB(170, 182, 110)' },
    { name: 'Real Estate', value: 4, color: 'RGB(132, 154, 167)' },
    { name: 'IT Consulting', value: 7, color: 'RGB(228, 114, 87)' },
    { name: 'Marketing', value: 5, color: 'RGB(65, 104, 138)' },
  ],
  Atlanta: [
    { name: 'Tech Services', value: 10, color: 'RGB(111, 143, 147)' },
    { name: 'Health', value: 9, color: 'RGB(195, 206, 170)' },
    { name: 'Marketing', value: 8, color: 'RGB(170, 182, 110)' },
    { name: 'Finance', value: 7, color: 'RGB(132, 154, 167)' },
    { name: 'Hospitality', value: 5, color: 'RGB(228, 114, 87)' },
    { name: 'Recruiting', value: 5, color: 'RGB(65, 104, 138)' },
  ],
  Dallas: [
    { name: 'Energy/Oil', value: 11, color: 'RGB(111, 143, 147)' },
    { name: 'IT Consulting', value: 7, color: 'RGB(195, 206, 170)' },
    { name: 'Saas', value: 7, color: 'RGB(170, 182, 110)' },
    { name: 'Hospital/Healthcare', value: 4, color: 'RGB(228, 114, 87)' },
    { name: 'Real Estate', value: 6, color: 'RGB(65, 104, 138)' },
  ],
  Houston: [
    { name: 'Energy/Oil', value: 35, color: 'RGB(111, 143, 147)' },
    { name: 'Health/Biotech', value: 4, color: 'RGB(195, 206, 170)' },
    { name: 'IT Consulting', value: 8, color: 'RGB(170, 182, 110)' },
    { name: 'Legal', value: 4, color: 'RGB(132, 154, 167)' },
    { name: 'Telecom', value: 3, color: 'RGB(228, 114, 87)' },
    { name: 'Consulting', value: 3, color: 'RGB(65, 104, 138)' },
  ],
  San_Antonio: [
    { name: 'IT Consulting', value: 9, color: 'RGB(111, 143, 147)' },
    { name: 'Construction', value: 8, color: 'RGB(195, 206, 170)' },
    { name: 'Real Estate', value: 7, color: 'RGB(170, 182, 110)' },
    { name: 'Medical Offices', value: 5, color: 'RGB(132, 154, 167)' },
    { name: 'Electronics', value: 5, color: 'RGB(228, 114, 87)' },
    { name: 'IT Security', value: 5, color: 'RGB(65, 104, 138)' },
  ],
  East_Bay: [
    { name: 'IT Consulting', value: 11, color: 'RGB(111, 143, 147)' },
    { name: 'Biotech', value: 9, color: 'RGB(195, 206, 170)' },
    { name: 'Fintech', value: 7, color: 'RGB(170, 182, 110)' },
    { name: 'Environmental', value: 3, color: 'RGB(132, 154, 167)' },
    { name: 'AI', value: 3, color: 'RGB(228, 114, 87)' },
    { name: 'Saas', value: 11, color: 'RGB(65, 104, 138)' },
  ],
  San_Francisco: [
    { name: 'Fintech', value: 13, color: 'RGB(111, 143, 147)' },
    { name: 'Saas', value: 11, color: 'RGB(195, 206, 170)' },
    { name: 'Biotech/Health', value: 10, color: 'RGB(170, 182, 110)' },
    { name: 'Marketplace', value: 5, color: 'RGB(132, 154, 167)' },
    { name: 'Consumer', value: 4, color: 'RGB(228, 114, 87)' },
    { name: 'DevOps', value: 4, color: 'RGB(65, 104, 138)' },
  ],
  Silicon_Valley: [
    { name: 'Biotech/Health', value: 16, color: 'RGB(111, 143, 147)' },
    { name: 'Fintech', value: 9, color: 'RGB(195, 206, 170)' },
    { name: 'Saas', value: 9, color: 'RGB(170, 182, 110)' },
    { name: 'DevOps/Security', value: 9, color: 'RGB(132, 154, 167)' },
    { name: 'AI/Analytics', value: 8, color: 'RGB(228, 114, 87)' },
    { name: 'Communication', value: 4, color: 'RGB(65, 104, 138)' },
  ],
  Santa_Barbara: [
    { name: 'Finance', value: 5, color: 'RGB(111, 143, 147)' },
    { name: 'Medical Equip', value: 4, color: 'RGB(195, 206, 170)' },
    { name: 'Health', value: 3, color: 'RGB(170, 182, 110)' },
    { name: 'Saas', value: 3, color: 'RGB(132, 154, 167)' },
    { name: 'Hospital/Healthcare', value: 3, color: 'RGB(228, 114, 87)' },
    { name: 'Food', value: 3, color: 'RGB(65, 104, 138)' },
  ],
  Los_Angeles: [
    { name: 'Saas', value: 10, color: 'RGB(111, 143, 147)' },
    { name: 'Entertainment', value: 7, color: 'RGB(195, 206, 170)' },
    { name: 'Apparel', value: 6, color: 'RGB(170, 182, 110)' },
    { name: 'Media', value: 6, color: 'RGB(132, 154, 167)' },
    { name: 'Food', value: 6, color: 'RGB(228, 114, 87)' },
    { name: 'Fintech', value: 5, color: 'RGB(65, 104, 138)' },
  ],
  Orange_County: [
    { name: 'Finance', value: 9, color: 'RGB(111, 143, 147)' },
    { name: 'Construction', value: 5, color: 'RGB(195, 206, 170)' },
    { name: 'Hospital/Healthcare', value: 10, color: 'RGB(170, 182, 110)' },
    { name: 'Saas', value: 5, color: 'RGB(132, 154, 167)' },
    { name: 'Marketing', value: 5, color: 'RGB(228, 114, 87)' },
    { name: 'Fintech', value: 5, color: 'RGB(65, 104, 138)' },
  ],

  San_Diego: [
    { name: 'IT Consulting', value: 8, color: 'RGB(111, 143, 147)' },
    { name: 'Biotech', value: 21, color: 'RGB(195, 206, 170)' },
    { name: 'Marketing', value: 7, color: 'RGB(170, 182, 110)' },
    { name: 'Medical Equip', value: 5, color: 'RGB(132, 154, 167)' },
    { name: 'Martech', value: 4, color: 'RGB(228, 114, 87)' },
    { name: 'Hospital/Healthcare', value: 3, color: 'RGB(65, 104, 138)' },
  ],
  Seattle: [
    { name: 'SaaS', value: 26, color: 'RGB(111, 143, 147)' },
    { name: 'Biotech/Medical', value: 7, color: 'RGB(195, 206, 170)' },
    { name: 'IT Consulting', value: 7, color: 'RGB(170, 182, 110)' },
    { name: 'Consumer', value: 5, color: 'RGB(132, 154, 167)' },
    { name: 'Real Estate', value: 4, color: 'RGB(228, 114, 87)' },
    { name: 'Learning', value: 3, color: 'RGB(65, 104, 138)' },
  ],
  Portland: [
    { name: 'SaaS', value: 15, color: 'RGB(111, 143, 147)' },
    { name: 'Real Estate', value: 9, color: 'RGB(195, 206, 170)' },
    { name: 'Marketing', value: 6, color: 'RGB(170, 182, 110)' },
    { name: 'Consumer', value: 4, color: 'RGB(132, 154, 167)' },
    { name: 'Consulting', value: 4, color: 'RGB(228, 114, 87)' },
    { name: 'IT Security', value: 3, color: 'RGB(65, 104, 138)' },
  ],
  New_York_City: [
    { name: 'Fintech', value: 17, color: 'RGB(111, 143, 147)' },
    { name: 'SaaS', value: 15, color: 'RGB(195, 206, 170)' },
    { name: 'Biotech/Health', value: 12, color: 'RGB(170, 182, 110)' },
    { name: 'Finance/Investments', value: 6, color: 'RGB(132, 154, 167)' },
    { name: 'Real Estate', value: 5, color: 'RGB(228, 114, 87)' },
    { name: 'Data Services', value: 4, color: 'RGB(65, 104, 138)' },
  ],
  Chicago: [
    { name: 'Fintech', value: 8, color: 'RGB(111, 143, 147)' },
    { name: 'Finance', value: 7, color: 'RGB(195, 206, 170)' },
    { name: 'Consumer', value: 5, color: 'RGB(170, 182, 110)' },
    { name: 'IT Consulting', value: 5, color: 'RGB(132, 154, 167)' },
    { name: 'Hospital/Healthcare', value: 4, color: 'RGB(228, 114, 87)' },
    { name: 'SaaS', value: 12, color: 'RGB(65, 104, 138)' },
  ],
  Boulder: [
    { name: 'SaaS', value: 11, color: 'RGB(111, 143, 147)' },
    { name: 'Biotech', value: 7, color: 'RGB(195, 206, 170)' },
    { name: 'IT Security', value: 3, color: 'RGB(170, 182, 110)' },
    { name: 'IT Consulting', value: 7, color: 'RGB(132, 154, 167)' },
    { name: 'Hospital/Healthcare', value: 9, color: 'RGB(228, 114, 87)' },
    { name: 'Environmental', value: 7, color: 'RGB(65, 104, 138)' },
  ],
  Denver: [
    { name: 'SaaS', value: 18, color: 'RGB(111, 143, 147)' },
    { name: 'Energy/Oil', value: 8, color: 'RGB(195, 206, 170)' },
    { name: 'Construction', value: 7, color: 'RGB(170, 182, 110)' },
    { name: 'Cannabis', value: 6, color: 'RGB(132, 154, 167)' },
    { name: 'Real Estate', value: 5, color: 'RGB(228, 114, 87)' },
    { name: 'IT Consulting', value: 5, color: 'RGB(65, 104, 138)' },
  ],
  Toronto: [
    { name: 'SaaS', value: 17, color: 'RGB(111, 143, 147)' },
    { name: 'Fintech', value: 10, color: 'RGB(195, 206, 170)' },
    { name: 'Cannabis', value: 6, color: 'RGB(170, 182, 110)' },
    { name: 'IT Consulting', value: 7, color: 'RGB(132, 154, 167)' },
    { name: 'Medical/Health', value: 5, color: 'RGB(228, 114, 87)' },
    { name: 'Finance', value: 4, color: 'RGB(65, 104, 138)' },
  ],
  Jacksonville: [
    { name: 'Logistics/Trans', value: 8, color: 'RGB(111, 143, 147)' },
    { name: 'Construction', value: 7, color: 'RGB(195, 206, 170)' },
    { name: 'NonProfit', value: 5, color: 'RGB(170, 182, 110)' },
    { name: 'IT Consulting', value: 6, color: 'RGB(132, 154, 167)' },
    { name: 'Hospital/Health', value: 5, color: 'RGB(228, 114, 87)' },
    { name: 'Recruiting', value: 5, color: 'RGB(65, 104, 138)' },
  ],
  Tampa: [
    { name: 'SaaS', value: 11, color: 'RGB(111, 143, 147)' },
    { name: 'Marketing', value: 6, color: 'RGB(195, 206, 170)' },
    { name: 'IT Security', value: 5, color: 'RGB(170, 182, 110)' },
    { name: 'IT Consulting', value: 14, color: 'RGB(132, 154, 167)' },
    { name: 'Defense', value: 5, color: 'RGB(228, 114, 87)' },
    { name: 'Recruiting', value: 4, color: 'RGB(65, 104, 138)' },
  ],
  Orlando: [
    { name: 'SaaS', value: 5, color: 'RGB(111, 143, 147)' },
    { name: 'Real Estate', value: 13, color: 'RGB(195, 206, 170)' },
    { name: 'Construction', value: 6, color: 'RGB(170, 182, 110)' },
    { name: 'IT Consulting', value: 10, color: 'RGB(132, 154, 167)' },
    { name: 'Recruiting', value: 5, color: 'RGB(228, 114, 87)' },
    { name: 'Finance', value: 6, color: 'RGB(65, 104, 138)' },
  ],
  Miami: [
    { name: 'SaaS', value: 5, color: 'RGB(111, 143, 147)' },
    { name: 'Marketing', value: 9, color: 'RGB(195, 206, 170)' },
    { name: 'Pharma', value: 5, color: 'RGB(170, 182, 110)' },
    { name: 'Real Estate', value: 6, color: 'RGB(132, 154, 167)' },
    { name: 'Medical/Health', value: 8, color: 'RGB(228, 114, 87)' },
    { name: 'Finance', value: 7, color: 'RGB(65, 104, 138)' },
  ],
  Detroit: [
    { name: 'Automotive', value: 10, color: 'RGB(111, 143, 147)' },
    { name: 'IT Consulting', value: 9, color: 'RGB(195, 206, 170)' },
    { name: 'SaaS', value: 6, color: 'RGB(170, 182, 110)' },
    { name: 'Finance', value: 6, color: 'RGB(132, 154, 167)' },
    { name: 'Recruiting', value: 4, color: 'RGB(228, 114, 87)' },
    { name: 'Biotech/Medical', value: 4, color: 'RGB(65, 104, 138)' },
  ],
  Pittsburgh: [
    { name: 'Hospital/Health', value: 8, color: 'RGB(111, 143, 147)' },
    { name: 'Medical Equip', value: 6, color: 'RGB(195, 206, 170)' },
    { name: 'Finance', value: 6, color: 'RGB(170, 182, 110)' },
    { name: 'IT Consulting', value: 4, color: 'RGB(132, 154, 167)' },
    { name: 'Real Estate', value: 4, color: 'RGB(228, 114, 87)' },
    { name: 'Robotics', value: 4, color: 'RGB(65, 104, 138)' },
  ],
  Phoenix: [
    { name: 'IT Consulting', value: 9, color: 'RGB(111, 143, 147)' },
    { name: 'Real Estate', value: 8, color: 'RGB(195, 206, 170)' },
    { name: 'SaaS', value: 7, color: 'RGB(170, 182, 110)' },
    { name: 'Education', value: 5, color: 'RGB(132, 154, 167)' },
    { name: 'Insurance', value: 5, color: 'RGB(228, 114, 87)' },
    { name: 'IT Security', value: 4, color: 'RGB(65, 104, 138)' },
  ],
  Minneapolis: [
    { name: 'Medical Equip', value: 7, color: 'RGB(111, 143, 147)' },
    { name: 'SaaS', value: 7, color: 'RGB(195, 206, 170)' },
    { name: 'IT Consulting', value: 6, color: 'RGB(170, 182, 110)' },
    { name: 'Hospital/Health', value: 6, color: 'RGB(132, 154, 167)' },
    { name: 'Finance', value: 6, color: 'RGB(228, 114, 87)' },
    { name: 'Engineering', value: 5, color: 'RGB(65, 104, 138)' },
  ],
  Salt_Lake_City: [
    { name: 'SaaS', value: 20, color: 'RGB(111, 143, 147)' },
    { name: 'IT Consulting', value: 6, color: 'RGB(195, 206, 170)' },
    { name: 'Finance', value: 6, color: 'RGB(170, 182, 110)' },
    { name: 'Hospital/Health', value: 5, color: 'RGB(132, 154, 167)' },
    { name: 'Real Estate', value: 5, color: 'RGB(228, 114, 87)' },
    { name: 'Marketing', value: 4, color: 'RGB(65, 104, 138)' },
  ],
  Washington_DC: [
    { name: 'IT Consulting', value: 26, color: 'RGB(111, 143, 147)' },
    { name: 'SaaS', value: 18, color: 'RGB(195, 206, 170)' },
    { name: 'IT Security', value: 10, color: 'RGB(170, 182, 110)' },
    { name: 'Pharma/Health', value: 6, color: 'RGB(132, 154, 167)' },
    { name: 'Finance/Fintech', value: 6, color: 'RGB(228, 114, 87)' },
    { name: 'Real Estate', value: 4, color: 'RGB(65, 104, 138)' },
  ],
  Nashville: [
    { name: 'Hospital/Health', value: 25, color: 'RGB(111, 143, 147)' },
    { name: 'Medical Offices', value: 6, color: 'RGB(195, 206, 170)' },
    { name: 'Real Estate', value: 6, color: 'RGB(170, 182, 110)' },
    { name: 'Marketing', value: 6, color: 'RGB(132, 154, 167)' },
    { name: 'Fintech', value: 5, color: 'RGB(228, 114, 87)' },
    { name: 'IT Consulting', value: 4, color: 'RGB(65, 104, 138)' },
  ],
  St_Louis: [
    { name: 'IT Consulting', value: 11, color: 'RGB(111, 143, 147)' },
    { name: 'Finance', value: 8, color: 'RGB(195, 206, 170)' },
    { name: 'Hospital/Healthcare', value: 7, color: 'RGB(170, 182, 110)' },
    { name: 'SaaS', value: 7, color: 'RGB(132, 154, 167)' },
    { name: 'Construction', value: 6, color: 'RGB(228, 114, 87)' },
    { name: 'Marketing', value: 6, color: 'RGB(65, 104, 138)' },
  ],
  Raleigh_Durham: [
    { name: 'SaaS', value: 13, color: 'RGB(111, 143, 147)' },
    { name: 'Pharma', value: 10, color: 'RGB(195, 206, 170)' },
    { name: 'Biotech', value: 8, color: 'RGB(170, 182, 110)' },
    { name: 'Consumer', value: 5, color: 'RGB(132, 154, 167)' },
    { name: 'Marketing', value: 5, color: 'RGB(228, 114, 87)' },
    { name: 'Telecom', value: 4, color: 'RGB(65, 104, 138)' },
  ],
  Kansas_City: [
    { name: 'Hospital/Health', value: 7, color: 'RGB(111, 143, 147)' },
    { name: 'IT Consulting', value: 7, color: 'RGB(195, 206, 170)' },
    { name: 'Marketing', value: 7, color: 'RGB(170, 182, 110)' },
    { name: 'SaaS', value: 7, color: 'RGB(132, 154, 167)' },
    { name: 'Transportation', value: 6, color: 'RGB(228, 114, 87)' },
    { name: 'Finance', value: 5, color: 'RGB(65, 104, 138)' },
  ],
  Charlotte: [
    { name: 'Construction', value: 8, color: 'RGB(111, 143, 147)' },
    { name: 'Real Estate', value: 7, color: 'RGB(195, 206, 170)' },
    { name: 'IT Consulting', value: 6, color: 'RGB(170, 182, 110)' },
    { name: 'SaaS', value: 6, color: 'RGB(132, 154, 167)' },
    { name: 'Finance', value: 5, color: 'RGB(228, 114, 87)' },
    { name: 'Hospital/Health', value: 4, color: 'RGB(65, 104, 138)' },
  ]
}



// WEBPACK FOOTER //
// ./client/src/common/const.js